import { TYPE_STATUS_ITEM } from 'commons/types';

export const PRODUCER_STATUS_ID = {
  APPROVED: 1,
  DISAPPROVED: 2,
  PENDING: 3,
};

export const PRODUCER_STATUS_BY_ID = {
  [PRODUCER_STATUS_ID.APPROVED]: 'Aprovado',
  [PRODUCER_STATUS_ID.DISAPPROVED]: 'Reprovado',
  [PRODUCER_STATUS_ID.PENDING]: 'Pendente',
};

export const ENTITY_STATUS_AUDITS = {
  DESBLOQUEADO: 1,
  BLOQUEADO: 2,
};

export const ITEM_STATUS = {
  [TYPE_STATUS_ITEM.AWAITING]: 'Pendente',
  [TYPE_STATUS_ITEM.APPROVED]: 'Aprovado',
  [TYPE_STATUS_ITEM.REPROVED]: 'Reprovado',
  [TYPE_STATUS_ITEM.SELECTED]: 'Escalado',
  [TYPE_STATUS_ITEM.DELETED]: 'Excluido',
  [TYPE_STATUS_ITEM.CANCELLED]: 'Cancelado',
  [TYPE_STATUS_ITEM.INVOICED]: 'Faturado',
  [TYPE_STATUS_ITEM.PARTIALLY_INVOICED]: 'Parcialmente faturado',
  [TYPE_STATUS_ITEM.CHECKED]: 'Conferido',
};

export const ORDER_STATUS_BY_ID = {
  1: ITEM_STATUS[TYPE_STATUS_ITEM.AWAITING],
  2: ITEM_STATUS[TYPE_STATUS_ITEM.APPROVED],
  3: ITEM_STATUS[TYPE_STATUS_ITEM.REPROVED],
  4: ITEM_STATUS[TYPE_STATUS_ITEM.SELECTED],
  5: ITEM_STATUS[TYPE_STATUS_ITEM.DELETED],
  6: ITEM_STATUS[TYPE_STATUS_ITEM.CANCELLED],
  7: ITEM_STATUS[TYPE_STATUS_ITEM.INVOICED],
  8: ITEM_STATUS[TYPE_STATUS_ITEM.PARTIALLY_INVOICED],
  9: ITEM_STATUS[TYPE_STATUS_ITEM.CHECKED],
};

export const ORDER_STATUS_ID = {
  [TYPE_STATUS_ITEM.AWAITING]: 1,
  [TYPE_STATUS_ITEM.APPROVED]: 2,
  [TYPE_STATUS_ITEM.REPROVED]: 3,
  [TYPE_STATUS_ITEM.SELECTED]: 4,
  [TYPE_STATUS_ITEM.DELETED]: 5,
  [TYPE_STATUS_ITEM.CANCELLED]: 6,
  [TYPE_STATUS_ITEM.INVOICED]: 7,
  [TYPE_STATUS_ITEM.PARTIALLY_INVOICED]: 8,
  [TYPE_STATUS_ITEM.CHECKED]: 9,
};

export const ORDER_STATUS_ID_BY_STATUS = {
  [ITEM_STATUS[TYPE_STATUS_ITEM.AWAITING]]: 1,
  [ITEM_STATUS[TYPE_STATUS_ITEM.APPROVED]]: 2,
  [ITEM_STATUS[TYPE_STATUS_ITEM.REPROVED]]: 3,
  [ITEM_STATUS[TYPE_STATUS_ITEM.SELECTED]]: 4,
  [ITEM_STATUS[TYPE_STATUS_ITEM.DELETED]]: 5,
  [ITEM_STATUS[TYPE_STATUS_ITEM.CANCELLED]]: 6,
  [ITEM_STATUS[TYPE_STATUS_ITEM.INVOICED]]: 7,
  [ITEM_STATUS[TYPE_STATUS_ITEM.PARTIALLY_INVOICED]]: 8,
  [ITEM_STATUS[TYPE_STATUS_ITEM.CHECKED]]: 9,
};
